import Vue from "vue";
import { AbacoWebModule, VueRegistration } from "@abaco/web-common/src/app";
import { WidgetMap } from "./models/Widget";
import OldWidgetsModule from ".";
import { PinnableTile } from "@abaco/dashboard-module/src/modules/dashboard/models/Dashboard";

export const ALLOWED_INDEXES = [
    "AGRIMETEO_FULL_GOOD_SOWING_COND",
    "AGRIMETEO_FULL_TSUOLO_5CM",
    "AGRIMETEO_PREV_SOMMA_TERMICA",
    "LOT_EXPOSURE",
    "LOT_NITRATES_HAZARD",
    "LOT_TOPOGRAPHIC_PROFILE",
    "TIMAC_FLUORIMETRO",
    "AGRIMETEO_HIST_HUMIDITY",
    "AGRIMETEO_HIST_WIND",
    "AGRIMETEO_PT_HIST_METEO",
    "AGRIMETEO_PT_FULL_METEO",
    "AGRIMETEO_PT_HIST_HUMIDITY",
    "AGRIMETEO_PT_HIST_WIND"
];
export const COLDIRETTI_ADDITIONAL_ALLOWED_INDEXES = [];

//export const OLD_ALLOWED_INDEXES = ['AGRIMETEO_FULL_EV', 'AGRIMETEO_FULL_GOOD_SOWING_COND', 'AGRIMETEO_FULL_METEO', 'AGRIMETEO_FULL_RAD', 'AGRIMETEO_FULL_TSUOLO_5CM', 'AGRIMETEO_FULL_TSUOLO', 'AGRIMETEO_FULL_WC', 'AGRIMETEO_PREV_SOMMA_TERMICA', 'COLDIRETTI_AGRIMETEO_PREV_EV', 'COLDIRETTI_AGRIMETEO_PREV_METEO', 'COLDIRETTI_AGRIMETEO_PREV_RAD', 'COLDIRETTI_AGRIMETEO_PREV_TSUOLO', 'COLDIRETTI_AGRIMETEO_PREV_WC', 'LOT_EXPOSURE', 'LOT_NITRATES_HAZARD', 'LOT_TOPOGRAPHIC_PROFILE', 'TIMAC_FLUORIMETRO', 'AGRIMETEO_HIST_HUMIDITY', 'AGRIMETEO_HIST_WIND', 'AGRIMETEO_HIST_METEO', 'AGRIMETEO_HIST_RAD', 'AGRIMETEO_HIST_SOMMA_TERMICA', 'AGRIMETEO_HIST_TSUOLO', 'AGRIMETEO_HIST_WC', 'AGRIMETEO_HIST_EV', 'AGRIMETEO_PT_HIST_METEO', 'AGRIMETEO_PT_FULL_METEO', 'AGRIMETEO_PT_HIST_HUMIDITY', 'AGRIMETEO_PT_HIST_WIND'];

export function createGlobals(
    widgetParams: WidgetMap,
    pinnableTiles: PinnableTile[],
    modulesByTileID: { [key: string]: AbacoWebModule },
    isColdiretti: boolean,
    module: OldWidgetsModule
) {
    const allowedIndexes = isColdiretti ? [...ALLOWED_INDEXES, ...COLDIRETTI_ADDITIONAL_ALLOWED_INDEXES] : ALLOWED_INDEXES;
    // Use the key in the WidgetMap as component name and id
    Object.entries(widgetParams).forEach(keyVal => {
        const key = keyVal[0];
        const value = keyVal[1];
        if (!allowedIndexes.includes(key)) {
            return;
        }
        Vue.component(key, () => import("./tiles/OldWidgetGeneralTile.vue"));

        pinnableTiles.push({
            module: OldWidgetsModule.MODULE_ID,
            metadata: {
                id: key,
                i18nDescrKey: value.title,
                pinnable: true,
                filters:
                    value.groupType === 1
                        ? [
                              "s-c-leader-select-nav-bar-item",
                              "farm-select-nav-bar-item",
                              "campaign-select-nav-bar-item",
                              "plot-selection-nav-bar-item"
                          ]
                        : []
            },
            tag: "STANDARD"
        });
        modulesByTileID[key] = module;
    });
}

export function deleteGlobals(widgetParams: WidgetMap, pinnableTiles: PinnableTile[], isColdiretti: boolean) {
    const allowedIndexes = isColdiretti ? [...ALLOWED_INDEXES, ...COLDIRETTI_ADDITIONAL_ALLOWED_INDEXES] : ALLOWED_INDEXES;
    Object.keys(widgetParams).forEach(key => {
        const index = pinnableTiles.findIndex(pt => pt.metadata.id === key && allowedIndexes.includes(key));
        if (index >= 0) {
            pinnableTiles.splice(index);
        }
    });
}

export const normalGlobals: VueRegistration = {
    DashMapCoordPlotMeasure: {
        meta: {
            i18nDescrKey: "map-coord-plot-measure",
            pinnable: true,
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            tag: "STANDARD"
        },
        component: () => import("./tiles/DashMapCoordPlotMeasure.vue")
    },
    DtmDsmTileChart: {
        meta: {
            i18nDescrKey: "dtm-dsm-tile-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD_PORTAL"
        },
        component: () => import("./tiles/DtmDsmTileChart.vue")
    },
    DashCompareWidgets: {
        meta: {
            i18nDescrKey: "compare-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "COMPARE_INDEX"
        },
        component: () => import("./tiles/DashCompareWidgets.vue")
    },
    SelectDateTileButton: () => import("./components/SelectDateTileButton.vue")
};
